<div class="filter-drop-down w-100 -mat-select-height-unset -border-bottom-none">
  <mat-form-field appearance="outline">
    <!-- <mat-label>Go to Page</mat-label> -->
    <input matInput type="number" placeholder="Enter page number" min="1" [(ngModel)]="pageNumber"
      (ngModelChange)="goToPage()" (keypress)="numberOnly($event)" placeholder="Go to Page">
  </mat-form-field>
</div>